import React, {
  useState,
  useCallback,
  useEffect,
} from 'react';
import { useManualQuery } from 'graphql-hooks';
import { useParams } from "react-router-dom";
import isEmpty from 'lodash/isEmpty';

import {
  VIDEO_BY_CODESHARE,
} from '../../graphql/video/query';
import { User, Video } from '../../types';
import { MobileFeed } from '../MobileFeed';

const Short: React.FC<{
  isMobile: boolean,
  innerHeight: number;
  user: User;
}> = (props) => {
  const {
    innerHeight,
    isMobile,
    user,
  } = props;
  const { codeshare } = useParams();
  const [video, setVideo] = useState({} as Video);
  const [videoByCodeshare] = useManualQuery(
    VIDEO_BY_CODESHARE,
    { skipCache: true },
  );

  const getVideo = useCallback(async () => {
    if (codeshare && codeshare.length === 9) {
      const { data } = await videoByCodeshare({
        variables: {
          codeshare,
        },
      });
      if (data && data.videoByCodeshare) {
        setVideo(data.videoByCodeshare);
      }
    }
  }, [codeshare, videoByCodeshare]);

  useEffect(() => {
    getVideo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ?redirect=42 ("Ouvrir l'app") never comes here on a phone: the server sends it to the store.
  if (video && isEmpty(video)) {
    return null;
  }

  // Phone only: on a computer the shared link is the feed (its video first).
  return (
    <MobileFeed
      isMobile={isMobile}
      user={user}
      innerHeight={innerHeight}
      firstVideo={video}
      single
    />
  );
};

export default React.memo(Short);
